import styled from "styled-components";

export const TrainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: -1%;
    margin-bottom: 5%;
    @media (max-width:600px) {
        margin-top:10%;
        margin-left: 9%;
    }
`